import React from 'react';

import DefaultSolutionTemplate from './default-solution-template';
import SectionHero from '../components/SectionHero';

const ContentFederationSolutionTemplate = (props) => (
  <DefaultSolutionTemplate {...props}>
    <SectionHero
      title="Mission critical content management, on your terms"
      description="Time matters when delivering content at an ambitious scale. GraphCMS provides you with central control of your enterprise content from multiple sources through a unified content layer."
    />
  </DefaultSolutionTemplate>
);

export default ContentFederationSolutionTemplate;
